var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8898 23.2917H8.84634C5.52445 23.2917 2.97601 22.0918 3.69988 17.2627L4.54275 10.7181C4.98898 8.30845 6.52597 7.38625 7.87456 7.38625H18.9013C20.2697 7.38625 21.7174 8.37786 22.2331 10.7181L23.0759 17.2627C23.6907 21.5464 21.2117 23.2917 17.8898 23.2917Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0386 7.14827C18.0386 4.56335 15.9431 2.46787 13.3582 2.46787V2.46787C12.1134 2.46259 10.9179 2.95338 10.0358 3.83169C9.15378 4.71001 8.65795 5.9035 8.65796 7.14827V7.14827",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.571 12.027H16.5214",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2545 12.027H10.2049",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActBag);
export default __webpack_public_path__ + "static/media/actBag.1224ba9415d178a28924d90a9f27688c.svg";
export { ForwardRef as ReactComponent };